import { useNavigate } from "react-router-dom";
import { AppBar, Box, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
/**
 *
 * @param {String} headLine main headline of the screen/route
 * @param {String} subHeadline sub headline of the screen/route
 * @param {Boolean} backButton
 * @param {Object} headlineActions
 * @returns
 */
const Header = ({
  headLine,
  subHeadline,
  backButton,
  children,
  headlineActions = () => {},
}) => {
  const { sideMenuOpen } = useSelector((state) => state.UI);
  const Navigate = useNavigate();

  return (
    <AppBar
      sx={{
        marginTop: "48px",
        backgroundColor: "#FFFFFF",
        height: "60px",
        borderBottom: "solid",
        borderBottomColor: "#E7E9EF",
        borderBottomWidth: "thin",
      }}
      elevation={0}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          marginLeft: sideMenuOpen ? "240px" : "64px",
          height: "60px",
          paddingLeft: "24px",
          paddingRight: "24px",
          width: window.innerWidth - (sideMenuOpen ? 240 : 64),
        }}
      >
        <Grid item sx={{ display: "flex" }}>
          {backButton ? (
            <KeyboardArrowLeftIcon
              sx={{ color: "#050D2E", paddingRight: "10px", cursor: "pointer" }}
              onClick={() => Navigate(-1)}
            />
          ) : null}
          <Box sx={{ display: "flex", gap: 1 }}>
            <Typography
              sx={{
                color: "#050D2E",
                fontWeight: 500,
                fontSize: "1.25rem",
                lineHeight: "22px",
                letterSpacing: "-0.67px",
                paddingRight: "10px",
              }}
            >
              {headLine}
            </Typography>
            {subHeadline ? (
              <Grid container sx={{ borderLeft: "2px solid #50566E" }}>
                <Grid item>
                  <Typography
                    sx={{
                      color: "#050D2E",
                      fontWeight: "550",
                      fontSize: "1rem",
                      lineHeight: "22px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      marginTop: "2px",
                    }}
                  >
                    {subHeadline}
                  </Typography>
                </Grid>
                <Grid item>
                  <KeyboardArrowDownIcon sx={{ color: "#050D2E" }} />
                </Grid>
              </Grid>
            ) : null}
            {headlineActions()}
          </Box>
        </Grid>
        <Grid item>{children}</Grid>
      </Grid>
    </AppBar>
  );
};

export default Header;
